import { BaseButton, Button, Checkbox, DefaultButton, Dialog, DialogFooter, DialogType, ICheckboxStyleProps, ICheckboxStyles, Icon, IconButton, IStyleFunction, PrimaryButton, SearchBox, TextField } from 'office-ui-fabric-react';
import React, { Fragment, useState } from 'react';

import * as http from '../../../http';

import { loadCurrentUser, user } from '../../../adalConfig';
import UserContext from '../../../UserContext';


import './DialogTestUser.scss';
import { Loading } from '../../Shared';





type Props = {
  children?: never;
  ref?: React.RefObject<WsDialogTestUser> | React.MutableRefObject<WsDialogTestUser | undefined>;
  // applications: EgApplication[];
  // addApplication: (application: EgApplication | undefined) => void;
  // setAddApplicationDialog: React.Dispatch<React.SetStateAction<boolean>>;
};



class WsDialogTestUser extends React.Component<Props, any> {

  static contextType = UserContext;

  // context!: React.ContextType<typeof UserContext>;

  constructor(props: any) {
    super(props);

    this.state = {
      dialogHidden: true,
      isLoading: false,
      showError: false,
      testUser: user.testUser
    };
  }


  show = () => {
    this.setState({ dialogHidden: false, isLoading: false, showError: false, testUser: user.testUser });
  }


  dismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined)  =>{
    this.setState({ dialogHidden: true });
  }


  hide = (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    this.setState({ dialogHidden: true });
  }


  save = async (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {

    this.setState({ isLoading: true });

    const result = await http.post<any>('/v2/users', { testAccount: `${this.state.testUser}` });

    if (result) {

      await loadCurrentUser(this.context?.setCurrentUser);

      this.setState({ dialogHidden: true });

    } else {

      this.setState({ isLoading: false, showError: true });
    }
  }


  change = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
    this.setState({ testUser: `${newValue}` });
  }


  render() {
    return (
      <Dialog
        className="ws-dialog-test-user"
        hidden={this.state.dialogHidden}
        onDismiss={this.dismiss}
        dialogContentProps={{
          type: DialogType.normal,
          title: 'Test Account',
          closeButtonAriaLabel: 'Close'
        }}
        modalProps={{
          isBlocking: false
        }}
      >
        <div className="ws-dialog-test-user-content">
          Please specify your test account<br />(e.g. VT6\uie00001) to be used for connecting to test machines (remote desktop)<br />
          <br />
          <TextField placeholder="VT6\uie00001" value={this.state.testUser} onChange={this.change} readOnly={this.state.isLoading} />
          { this.state.showError && <div className="ws-show-error">Account not found, please specify a valid account!</div> }
        </div>
        <DialogFooter>
          {/* <button className="button is-text" onClick={this.hide}>Cancel</button> */}
          { this.state.isLoading && <div className="ws-is-loading"><Loading /></div> }
          { !this.state.isLoading && <PrimaryButton onClick={this.save} text="Save" /> }
          <DefaultButton onClick={this.hide} text="Cancel" />
        </DialogFooter>
      </Dialog>
    );
  }
}



export {
  WsDialogTestUser
};
